import isEmptyObject from '../../../general/isEmpty/isEmptyObject';

import setAttr from '../../../general/attr/setAttr';

// ----------------------------------------------------------------------------

function setFields(form: HTMLFormElement, config: Record<string, any> = {}): void {
    // If there is data
    if (isEmptyObject(config.data)) {
        return;
    }

    // Foreach Data
    for (let key of Object.keys(config.data)) {
        const value = config.data[key];

        // --------------------------------------------------------------------

        // If using exclude
        if (config.exclude?.includes(key)) {
            continue;
        }

        // If using change
        if (config.change?.[key]) {
            key = config.change[key];
        }

        // --------------------------------------------------------------------

        // Get element (field)
        const elField = form.querySelector<any>('[name="' + key + '"]');
        // If there is no element (field)
        if (!elField) {
            continue;
        }

        // --------------------------------------------------------------------

        // If using disabled
        if (config.disabled?.includes(key)) {
            setAttr(elField, 'disabled', true);
        }

        // --------------------------------------------------------------------

        // If using function started
        if (typeof config.fnStarted === 'function') {
            config.fnStarted.call(elField, value, key);
        }
        // Is default
        else {
            // If there is function set value
            if (typeof elField.setValue === 'function') {
                elField.setValue(value);
            }
            // Is default
            else {
                elField.value = value;
            }
        }
    }
}

// ----------------------------------------------------------------------------

export default setFields;
